<section class="card-wrapper-container">
  <ng-container *ngFor="let card of playerList">
    <app-bronze-card class="card-wrapper" *ngIf="card?.player?.category?.id === 3" [card]="card"></app-bronze-card>
    <app-silver-card class="card-wrapper" *ngIf="card?.player?.category?.id === 2" [card]="card"></app-silver-card>
    <app-golden-card class="card-wrapper" *ngIf="card?.player?.category?.id === 1" [card]="card"></app-golden-card>
  </ng-container>
</section>
